<template>
  <div id="contenedor-calendario-actividades-contratos">
    <v-row class="fill-height">
      <v-col>
        <v-sheet height="110">
          <v-toolbar
            flat>
            <v-btn
              outlined
              class="mr-4"
              color="grey darken-2"
              @click="setHoy">
              Hoy
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="anterior">
              <v-icon small>
                mdi-chevron-left
              </v-icon>
            </v-btn>
            <v-toolbar-title
            v-if="$refs.calendar"
            class="text-uppercase">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="siguiente">
              <v-icon small>
                mdi-chevron-right
              </v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-menu
              bottom
              right>
              <template v-slot:activator="{ on, attrs }">
                <!-- <custom-button
                  :label="typeToLabel[type]"
                  iconText="mdi-menu-down"
                  tipo="agregar"
                  v-bind="attrs"
                  v-on="on">
                </custom-button> -->
                <v-btn
                  outlined
                  color="grey darken-2"
                  v-bind="attrs"
                  v-on="on">
                  <span>{{ typeToLabel[type] }}</span>
                  <v-icon right>
                    mdi-menu-down
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="type = 'day'">
                  <v-list-item-title>Día</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'week'">
                  <v-list-item-title>Semana</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'month'">
                  <v-list-item-title>Mes</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
          <!-- Nomenclatura de actividades de contratos -->
          <v-row justify="center">
              <v-chip
                class="mx-1"
                color="#43BC82"
                outlined
                dark>
                  <h3>Plazo mayor a 5 días</h3>
                </v-chip>
                <v-chip
                class="mx-1"
                color="#FA8B00"
                outlined
                dark>
                  <h3>Fecha vencida / próxima a vencer</h3>
              </v-chip>
              <v-tooltip top>
              <template
                v-slot:activator="{ on, attrs }">
                <v-chip
                  class="mx-1"
                  color="#EF5350"
                  outlined
                  dark
                  v-bind="attrs"
                  v-on="on"
                  @click="listadoActividadesVencidas.mostrar = true">
                  <h3>Ver Pendientes Vencidos</h3>
                </v-chip>
                <!-- <custom-button
                  label="Actividades Vencidas"
                  tipo="formCancelar"
                  @click="listadoActividadesVencidas.mostrar = true"
                  v-bind="attrs"
                  v-on="on">
                </custom-button> -->
              </template>
              <span>
                Ver Actividades Vencidas
              </span>
            </v-tooltip>
          </v-row>
        </v-sheet>
        <v-sheet height="900">
          <v-calendar
            ref="calendar"
            v-model="focus"
            color="grey lighten-2"
            :events="actividades"
            :event-color="getActividadColor"
            :type="type"
            @click:event="mostrarEvento"
            @click:more="verDia"
            @click:date="verDia">
          </v-calendar>
          <!-- Menu de evento -->
          <v-menu
            v-model="abrirSeleccionado"
            :close-on-content-click="false"
            :activator="elementoSeleccionado"
            offset-x
            min-width="350px"
            max-width="350px">
            <!-- card de informacion del evento -->
            <v-card
              color="grey lighten-4"
              min-width="350px"
              max-width="350px"
              flat>
              <v-toolbar
                :color="getActividadColor(actividadSeleccionada)"
                dark>
                <v-toolbar-title v-html="actividadSeleccionada.name"></v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-row>
                  <h3>Descripción: {{ actividadSeleccionada.descripcion }}</h3>
                </v-row>
                <v-row>
                  <h3>
                    Fecha Plazo: {{ new Date(actividadSeleccionada.start).toLocaleDateString()}}
                  </h3>
                </v-row>
                <v-spacer></v-spacer>
                <v-row>
                  <h3>Estatus: {{actividadSeleccionada.estatus}}</h3>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <custom-button
                  @click="abrirSeleccionado = false"
                  tipo="formCancelar"
                  label="Cerrar"
                  class="mr-3"
                >
                </custom-button>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog
      v-if="listadoActividadesVencidas.listado"
      v-model="listadoActividadesVencidas.mostrar"
      width="1000"
      scrollable>
      <v-card>
        <v-card-title class="secondary--text">
          Pendientes con fecha de plazo vencida
          <v-spacer></v-spacer>
          <v-btn icon @click="listadoActividadesVencidas.mostrar = false">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <listado-actividades-vencidas
            :listado="listadoActividadesVencidas.listado">
          </listado-actividades-vencidas>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
            <custom-button
              @click="listadoActividadesVencidas.mostrar = false"
              tipo="formCancelar"
              label="Cerrar"
              class="mr-3">
            </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ListadoActividadesVencidas from './ListadoVencidas.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CalendarioActividadesContratos',
  props: {
    actividadesTodas: {
      type: Array,
      required: false,
    },
    listadoContratos: {
      type: Array,
      required: true,
    },
  },
  components: {
    ListadoActividadesVencidas,
    CustomButton,
  },
  data: () => ({
    focus: '',
    type: 'month',
    typeToLabel: {
      month: 'Mes',
      week: 'Semana',
      day: 'Día',
    },
    actividadSeleccionada: {},
    elementoSeleccionado: null,
    abrirSeleccionado: false,
    actividades: [],
    listadoActividadesVencidas: {
      mostrar: false,
      listado: null,
    },
  }),
  mounted() {
    this.$refs.calendar.checkChange();
    this.setActividades();
  },
  methods: {
    verDia({ date }) {
      this.focus = date;
      this.type = 'day';
    },
    getActividadColor(event) {
      if (event.color === 1) return '#43BC82';
      return '#FA8B00';
    },
    setHoy() {
      this.focus = '';
    },
    anterior() {
      this.$refs.calendar.prev();
    },
    siguiente() {
      this.$refs.calendar.next();
    },
    mostrarEvento({ nativeEvent, event }) {
      const open = () => {
        this.actividadSeleccionada = event;
        this.elementoSeleccionado = nativeEvent.target;
        requestAnimationFrame(() => requestAnimationFrame(() => {
          this.abrirSeleccionado = true;
        }));
      };

      if (this.abrirSeleccionado) {
        this.abrirSeleccionado = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    // Crear actividades de Calendario
    setActividades() {
      const actividades = [];
      if (this.actividadesTodas.length === 0 || this.listadoContratos.length === 0) return;
      const actividadesEstatusAbierto = this.actividadesTodas
        .filter((actividad) => actividad.estatus === 'Abierta')
        // agrego el contrato a la activdad
        .map((actividad) => ({
          ...actividad,
          contrato: this.listadoContratos
            .find((contrato) => contrato.id === actividad.idReferencia),
        }));

      actividadesEstatusAbierto.forEach((actividad) => {
        if (actividad.completa) return;
        actividades.push({
          name: `${actividad.contrato?.numero} - ${actividad.descripcion}`,
          descripcion: actividad.descripcion,
          start: new Date(`${actividad.fechaPlazo} 00:00:0`),
          end: new Date(`${actividad.fechaPlazo} 00:00:0`),
          estatus: actividad.estatus,
          color: this.setColor(actividad),
          timed: false,
        });
      });
      this.setActividadesVencidas(actividadesEstatusAbierto);
      this.actividades = actividades;
    },
    setActividadesVencidas(actividades) {
      const actividadesVencidas = actividades
        .filter((actividad) => this.getPlazo(actividad.fechaPlazo) === 0);
      this.listadoActividadesVencidas.listado = actividadesVencidas;
    },
    setColor(actividad) {
      const plazo = this.getPlazo(actividad.fechaPlazo);
      if (plazo > 5) return 1;
      return 0;
    },
    getPlazo(fechaPlazo) {
      // Dia de hoy
      const fechaHoy = new Date();
      // Dia de hoy sin horas
      const fechaHoySinHora = `${fechaHoy.getFullYear()}/${fechaHoy.getMonth() + 1}/${fechaHoy.getDate()}`;
      // Dia de hoy con horas en ceros
      const fechaHoyHoraCero = new Date(`${fechaHoySinHora} 00:00:0`);
      const fechadePlazo = new Date(`${fechaPlazo} 00:00:0`);
      const a = this.$moment(fechaHoyHoraCero);
      const b = this.$moment(fechadePlazo);
      // Dias para llegar a fecha de plazo
      // Si la fecha de hoy es igual a la del plazo sumo 1 dia
      // como el disponible para realizar la actividad
      const plazo = (Number(b.diff(a, 'days')) + 1);

      // cuando el plazo sea menor a cero siempre seran 0 los dias disponibles
      if (plazo < 0) return 0;

      return plazo;
    },
    horaFormatoHrs(fechaHora) {
      const fecha = new Date(fechaHora);
      const horas = fecha.getHours().toString().length === 1 ? `0${fecha.getHours()}` : fecha.getHours();
      const minutos = fecha.getMinutes().toString().length === 1 ? `0${fecha.getMinutes()}` : fecha.getMinutes();
      return `${horas}:${minutos}`;
    },
  },
};
</script>

<style>

</style>
